// extracted by mini-css-extract-plugin
export var collapsedSummary = "_ry-0";